import React from "react";

export const SettingsPage = () => {
  const clientId = window.localStorage.getItem("clientId");
  const apiKey = window.localStorage.getItem("apiKey");

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl md:text-2xl font-semibold text-slate-900">
          Settings
        </h1>
        <p className="text-xs md:text-sm text-slate-400 mt-1">
          Basic configuration for this business. For now this is mostly read
          only — we&apos;ll wire deeper settings later.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <h2 className="text-sm font-medium text-slate-900 mb-2">
            Client Information
          </h2>
          <div className="text-xs text-slate-700 space-y-2">
            <div>
              <span className="text-slate-600">Client ID: </span>
              <span className="font-mono text-[11px]">
                {clientId || "Not set"}
              </span>
            </div>
            <div>
              <span className="text-slate-600">API Key: </span>
              <span className="font-mono text-[11px]">
                {apiKey ? `${apiKey.substring(0, 12)}...` : "Not set"}
              </span>
            </div>
            <div className="text-slate-400 text-[11px] mt-2">
              Client ID and API key are used to authenticate your requests to
              the backend. These are set during onboarding.
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <h2 className="text-sm font-medium text-slate-900 mb-2">
            Integrations (coming soon)
          </h2>
          <ul className="text-xs text-slate-700 space-y-1">
            <li>• Google Calendar sync</li>
            <li>• CRM push (HubSpot / Pipedrive)</li>
            <li>• Missed-call SMS follow-up controls</li>
            <li>• Alert routing (email, Slack, SMS)</li>
          </ul>
          <p className="text-[11px] text-slate-500 mt-2">
            For now, all core intelligence (CallBrain, Booking Engine,
            Playbooks) is controlled from the backend. This page will become
            your control center later.
          </p>
        </div>
      </div>
    </div>
  );
};
